/**
 * The only places the app navigates toward a purchase. Each is `null` where
 * commerce is off (see policy.ts), so call sites must check before rendering.
 */

import type { Router } from 'expo-router';
import { ifCommerce } from './policy';

export type PlanRole = 'startup' | 'investor';
type Push = Pick<Router, 'push'>;

const PLANS_ROUTE = {
  startup: '/(startup)/startup-subscription',
  investor: '/(investor)/investor-subscription',
} as const;

function goToPlans(router: Push, role: PlanRole): void {
  router.push(PLANS_ROUTE[role]);
}

export interface CommerceLink {
  label: string;
  open: (router: Push, role: PlanRole) => void;
}

export interface ReferralLink {
  label: string;
  open: (router: Push) => void;
}

/** For CTAs that are not a labelled row (e.g. a locked Team Management tap). */
export const openPlans = ifCommerce(goToPlans, null);

export const PLANS_LINK: CommerceLink | null = ifCommerce({ label: 'Subscription & Billing', open: goToPlans }, null);
export const COMPANY_PLANS_LINK: CommerceLink | null = ifCommerce({ label: 'Subscription & Pricing', open: goToPlans }, null);
export const PROFILE_PLANS_LINK: CommerceLink | null = ifCommerce({ label: 'Subscription', open: goToPlans }, null);

export const REFERRAL_LINK: ReferralLink | null = ifCommerce(
  { label: 'Referral Program', open: (router: Push) => router.push('/referral') },
  null,
);
